import React, { lazy } from "react";

const LazyCalculateTaxes = lazy(() => import("./CalculateTaxes"));

const CalculateTaxes = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyCalculateTaxes {...props} />;

export default CalculateTaxes;
